/** Trader channel name for measurement / study add-on lines (no DSP fees). */
export const MEASUREMENT_CHANNEL = 'Measurement';

export function isMeasurementChannel(channel?: string | null): boolean {
  return channel?.trim().toLowerCase() === MEASUREMENT_CHANNEL.toLowerCase();
}
